<template>
  <div>
    <h1 class="mb-5">View Access Requests</h1>

    <b-modal id="modal-crud" hide-header hide-footer size="lg" aria-label="Request Detail Modal">
      <h2>Request</h2>
      <hr/>
      <EmployerDetail
        :request="requestData"
        :type="filters.type"
        v-on:refresh-list="refresh()"
      />
    </b-modal>
    <b-row>
      <b-col cols="12" lg="4">
        <label for="selectStatus">
          <strong>Type of request:</strong>
        </label>
        <br/>
        <b-form-select
          id="selectStatus"
          :state="null"
          :options="sortOptions"
          v-model="filters.type"
          @change="initialize"
        />
      </b-col>
    </b-row>
    <div v-if="filters.type">
      <b-row>
        <b-col cols="12" lg="4">
          <label for="selectStatus">
            <strong>Request status:</strong>
          </label>
          <br/>
          <b-form-select
            id="selectStatus"
            :state="null"
            :options="statusOptions"
            v-model="filters.status"
            @change="initialize"
          />
        </b-col>
      </b-row>
      <br/>
      <b-table v-if="this.filters.type === 'Organization'"
               hover small responsive show-empty bordered
               :fields="orgFields"
               :items="requests"
               :busy="isLoading"
               :filter="filters">
        <template v-slot:cell(actions)="row">
          <b-button variant="primary" role="button" size="sm" @click="showRequest(row.item)" class="mr-1">
            view
          </b-button>
        </template>

        <template v-slot:no-data>
          <p>No data.</p>
        </template>

        <template v-slot:empty="scope">
          <p>No {{ filters.status.toLowerCase() }} requests found.</p>
        </template>

        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
        </div>
      </b-table>
      <b-table v-if="this.filters.type === 'Facility'"
               hover small responsive show-empty bordered
               :fields="facFields"
               :items="requests"
               :busy="isLoading"
               :filter="filters">
        <template v-slot:cell(actions)="row">
          <b-button variant="primary" role="button" size="sm" @click="showRequest(row.item)" class="mr-1">
            view
          </b-button>
        </template>

        <template v-slot:no-data>
          <p>No data.</p>
        </template>

        <template v-slot:empty="scope">
          <p>No {{ filters.status.toLowerCase() }} requests found.</p>
        </template>

        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
        </div>
      </b-table>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import EmployerDetail from '@/components/EmployerDetail'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    components: {
      EmployerDetail,
    },
    data: () => ({
      orgFields: [
        {key: 'firstName', sortable: true, label: 'First Name'},
        {key: 'lastName', sortable: true, label: 'Last Name'},
        {key: 'businessName', sortable: true, label: 'Organization Name'},
        {key: 'facilityName', sortable: true, label: 'Facility Name'},
        {key: 'intendedUse', sortable: true, label: 'Intended Use'},
        {key: 'actions', label: 'Actions'}
      ],
      facFields: [
        {key: 'facilityName', sortable: true, label: 'Facility Name'},
        {key: 'firstName', sortable: true, label: 'First Name'},
        {key: 'lastName', sortable: true, label: 'Last Name'},
        {key: 'businessName', sortable: true, label: 'Organization Name'},

        {key: 'intendedUse', sortable: true, label: 'Intended Use'},
        {key: 'actions', label: 'Actions'}
      ],
      isLoading: false,
      requests: [],
      requestData: {},
      statusOptions: [
        { value: 'PENDING', text: 'PENDING' },
        { value: 'DENIED', text: 'DENIED' },
        { value: 'APPROVED', text: 'APPROVED' }
      ],
      sortOptions: [
        { value: 'Organization', text: 'Organization' },
        { value: 'Facility', text: 'Facility' },
      ],
      filters: {
        status: 'PENDING',
        type: ''
      },
    }),

    created () {
      this.initialize();
    },

    methods: {
      refresh() {
        this.getRequests();
      },

      getRequests() {
        this.isLoading = true;
        if (this.filters.type === 'Organization') {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/${this.filters.status}`)
            .then(response => {
              if (response.status === 200) {
                this.requests = response.data;
              }
                this.isLoading = false;
              }
            )
        } else if (this.filters.type === 'Facility') {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/facility/${this.filters.status}`)
            .then(response => {
                if (response.status === 200) {
                  this.requests = response.data;
                }
                this.isLoading = false;
              }
            )
        }

      },

      async showRequest(item) {
        this.requestData = item;
        this.$bvModal.show('modal-crud');
      },

      initialize () {
        this.getRequests();
      }
    }
  }
</script>
